import React from 'react'

function DoorOpenIcon() {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66667 8.88889C6.90278 8.88889 7.10069 8.8037 7.26042 8.63333C7.42014 8.46296 7.5 8.25185 7.5 8C7.5 7.74815 7.42014 7.53704 7.26042 7.36667C7.10069 7.1963 6.90278 7.11111 6.66667 7.11111C6.43056 7.11111 6.23264 7.1963 6.07292 7.36667C5.91319 7.53704 5.83333 7.74815 5.83333 8C5.83333 8.25185 5.91319 8.46296 6.07292 8.63333C6.23264 8.8037 6.43056 8.88889 6.66667 8.88889ZM3.33333 16V14.2222L8.33333 13.3333V3.44444C8.33333 3.22222 8.27083 3.02222 8.14583 2.84444C8.02083 2.66667 7.86111 2.56296 7.66667 2.53333L3.33333 1.77778V0L7.91667 0.8C8.52778 0.918519 9.02778 1.22222 9.41667 1.71111C9.80556 2.2 10 2.77037 10 3.42222V14.8L3.33333 16ZM0 16V14.2222H1.66667V1.77778C1.66667 1.27407 1.82986 0.851852 2.15625 0.511111C2.48264 0.17037 2.875 0 3.33333 0H11.6667C12.1389 0 12.5347 0.17037 12.8542 0.511111C13.1736 0.851852 13.3333 1.27407 13.3333 1.77778V14.2222H15V16H0ZM3.33333 14.2222H11.6667V1.77778H3.33333V14.2222Z"
        fill="white"
      />
    </svg>
  )
}

export default DoorOpenIcon
